"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DialogBox;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _material = require("@mui/material");
var _utils = require("../../utils");
function DialogBox(props) {
  const {
    title,
    size,
    message,
    children,
    leftButton,
    rightButtons,
    middleButtons,
    onClose,
    open,
    scrolled,
    skrim,
    style
  } = props;
  const hasFooter = leftButton || rightButtons || middleButtons;
  const {
    isMobile
  } = (0, _utils.useDeviceInfo)();
  return open ? /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box-container".concat(skrim ? '--skrim' : '', " ").concat(open ? 'dialog-box--opened' : 'dialog-box--closed', " ").concat(isMobile ? 'mobile' : ''),
    onClick: event => {
      if (event.target instanceof HTMLElement && event.target.classList.contains('dialog-box--opened')) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    },
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box dialog-box--".concat(size)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box--header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "close-icon-spacer"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close",
    className: "icon-close"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (hasFooter ? 'dialog-box--body' : 'dialog-box--body-no-footer') + (scrolled ? ' scrolled' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box--message"
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box--boundary"
  }, children)), hasFooter && /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box--footer"
  }, leftButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box--footer-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "left-button"
  }, leftButton), /*#__PURE__*/_react.default.createElement("div", {
    className: "right-buttons"
  }, rightButtons === null || rightButtons === void 0 ? void 0 : rightButtons.map((rb, index) => {
    const rbWithKey = {
      ...rb,
      key: "rb-".concat(index),
      props: {
        ...rb.props,
        size: rb.props.size || 'medium'
      }
    };
    return rbWithKey;
  }))), middleButtons && /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-box--actions-container"
  }, middleButtons === null || middleButtons === void 0 ? void 0 : middleButtons.map((mb, index) => {
    const mbWithKey = {
      ...mb,
      key: "mb-".concat(index),
      props: {
        ...mb.props,
        size: mb.props.size || 'medium'
      }
    };
    return mbWithKey;
  }))))) : null;
}